

import React,{useEffect} from 'react';
import '../Assets/Css/about.css'
import { Container, Row, Col, Card } from 'react-bootstrap';


import { FaBullseye, FaEye, FaHeart } from 'react-icons/fa';
import aboutimg from '../Assets/Image/gallery5.jpeg'
import { FaLeaf, FaHandsHelping, FaLightbulb } from 'react-icons/fa';

import AOS from 'aos';
import 'aos/dist/aos.css';
import { Helmet } from 'react-helmet';
import CountUp from 'react-countup';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { FaStar } from 'react-icons/fa';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import leftagrow from '../Assets/Image/plant3.png'
import rightagrow from '../Assets/Image/seedimage.jpg'

export default function About() {
  useEffect(() => {
        AOS.init({ duration: 1000 });
      }, []);

const whyChooseData = [
  {
    icon: <FaLeaf className="choose-icon-inner" />,
    title: "Organic First",
    desc: "Our programs are designed around certified premium organic practices with proven health and environmental benefits."
  },
  {
    icon: <FaHandsHelping className="choose-icon-inner" />,
    title: "Community Impact",
    desc: "We actively work with local schools, colleges, and community leaders to build grassroots movements."
  },
  {
    icon: <FaLightbulb className="choose-icon-inner" />,
    title: "Innovative Learning",
    desc: "We use experiential, hands-on training that transforms theory into impactful real-world applications."
  }
];

 const testimonials = [
  {
    text: "XtraGrow Foundation transformed our school’s approach to sustainability through hands-on organic farming.",
    role: "— Principal, Green Valley High School"
  },
  {
    text: "Thanks to XtraGrow, our students understand the value of organic agriculture and community nutrition.",
    role: "— Environmental Science Teacher"
  },
  {
    text: "This program brings real change. It’s not just education — it's empowerment through action.",
    role: "— Parent Volunteer"
  },
  {
    text: "XtraGrow’s workshops were the highlight of our school year. Students are now growing food at home!",
    role: "— Head of Student Council"
  },
  {
    text: "Partnering with XtraGrow was the best decision — they inspire change from the roots up.",
    role: "— NGO Coordinator"
  }
];


  return (
    <>
      <div className="mainnav min-vh-100">

<Helmet>
        <title>About Us | XtraGrow Foundation, Inc.</title>
        <meta
          name="description"
          content="Learn about XtraGrow Foundation’s mission to empower children from 4th grade to college with knowledge of premium organic agriculture and create healthy communities."
        />
        <meta
          name="keywords"
          content="XtraGrow Foundation, about XtraGrow, sustainable agriculture, organic farming education, youth empowerment, premium organic farming, community farming"
        />
        <meta name="author" content="XtraGrow Foundation, Inc." />
        <link rel="canonical" href="https://xtragrowfoundation.org/about" />

        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="About Us | XtraGrow Foundation" />
        <meta
          property="og:description"
          content="Discover how XtraGrow Foundation educates and empowers youth to lead in premium organic farming and community nutrition."
        />
        <meta property="og:url" content="https://xtragrowfoundation.org/about" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://xtragrowfoundation.org/images/about-us-banner.jpg"
        />

        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Us | XtraGrow Foundation" />
        <meta
          name="twitter:description"
          content="Our mission is to educate youth about premium organic farming and help create sustainable communities."
        />
        <meta
          name="twitter:image"
          content="https://xtragrowfoundation.org/images/about-us-banner.jpg"
        />
      </Helmet>

        {/* Hero Section */}
        <section className="hero-section1">
          <div className="overlay" >
            <h1 data-aos="zoom-in">About Us</h1>
            <p className='text-white' data-aos="zoom-in">Home | About Us</p>
         
          </div>


        </section>

        {/* About Section Preview */}
        {/* About Section */}
        <section className="about-preview py-5">
          <Container>
            <Row className="align-items-center">
              {/* Text Section */}
              <Col md={7}>
                <h2 className='page-title'  data-aos="fade-up" >Welcome to <br /> <span style={{color:'#078825'}}> Xtragrow Foundation, Inc</span> </h2>
                <div style={{ textAlign: 'justify' }} data-aos="zoom-in" data-aos-delay="100">
                 <p className='aboutpagetext'>
                  The Mission of the <span style={{ color: '#036839', fontWeight: 'bold' }}> XTRAGROW</span>
                    <span style={{ color: '#3CB649', fontWeight: 'bold' }}> Foundation, Inc., </span> [a recognized 501(c)3 under 509(a)(2)] is: To educate children between the ages of fourth grade and throughout college about the incredible benefits of Premium Organic agriculture practices. Furthermore, to develop, certify and assist them to create local premium organic farms in both our rural and urban settings thereby boosting the health, nutrition and well-being of our communities.
                </p>
                </div>
              </Col>
              <Col md={5}>
                <img
                  src={aboutimg}
                  alt="Teamwork and Services"
                  className="img-fluid aboutimgpage rounded shadow mb-3"
                  data-aos="zoom-in" data-aos-delay="200"
                />
              </Col>
              
             
              
            </Row>
          </Container>
        </section>


        <div className="mission-vision-bg py-5">
          <Container className='mb-4'>
            <h2 className='page-title'  data-aos="fade-up">Our <span style={{color:'#078825'}}> Mission & Vision</span>  </h2>
            <Row className="text-center justify-content-center align-items-start">

              <Col md={6} className="column-box  middle-box1" data-aos="zoom-in" data-aos-delay="100">
                <FaBullseye className="iconmain" />
                <h4 className="title">Our <span style={{color:'#078825'}}> Mission </span></h4>
                <p className="text">
                We envision a future where every child has access to knowledge and resources that empower them to become stewards of sustainable agriculture. Through our educational programs and partnerships, we strive to create a network of young leaders who are equipped to promote and practice Premium Organic farming, contributing to a healthier environment and stronger communities.
                </p>
              </Col>

              <Col md={6} className="column-box middle-box" data-aos="zoom-in" data-aos-delay="200">
                <FaEye className="iconmain" />
                <h4 className="title">Our <span style={{color:'#078825'}}>  Vision</span> </h4>
                <p className="text">
                 At XtraGrow Foundation, Inc., our mission is clear: to educate children from fourth grade through college about the exceptional benefits of Premium Organic agriculture practices. We are committed to developing, certifying, and supporting young individuals in establishing local premium organic farms in both rural and urban settings. By doing so, we aim to enhance the health, nutrition, and well-being of our communities.
                </p>
              </Col>
            </Row>
          </Container>
        </div>

       <section className="why-choose-us py-5">
  <Container>
    <h2 className="page-title text-center" data-aos="fade-up">
      Why <span style={{ color: '#078825' }}>Choose Us</span>
    </h2>
    <p className="text-center" data-aos="fade-up" data-aos-delay="100">
      We are committed to empowering future generations through sustainable organic farming education and practical implementation.
    </p>
    <Row className="mt-4">
      {whyChooseData.map((item, index) => (
        <Col key={index} md={4} sm={6} xs={12} className="mb-4" data-aos="zoom-in" data-aos-delay={index * 100 + 200}>
          <Card className="choose-card h-100 shadow-sm border-0 text-center p-4">
            <div className="choose-icon mb-3">{item.icon}</div>
            <h5 className="mb-2">{item.title}</h5>
            <p style={{ lineHeight: '1.6', fontSize: '0.95rem' }}>{item.desc}</p>
          </Card>
        </Col>
      ))}
    </Row>
  </Container>
</section>


<section className="impact-section py-5">
  <Container>
    <h2 className='page-title text-center mb-4' data-aos="fade-up">
      Our <span style={{ color: '#3CB649' }}>Impact</span>
    </h2>
    <Row className="text-center">
      <Col md={3} sm={6} xs={6} data-aos="zoom-in">
        <h3 className="impact-number"><CountUp end={30} duration={2} />+</h3>
        <p className="impact-label">Organic Projects</p>
      </Col>
      <Col md={3} sm={6} xs={6} data-aos="zoom-in" data-aos-delay="100">
        <h3 className="impact-number"><CountUp end={1500} duration={3} />+</h3>
        <p className="impact-label">Students Reached</p>
      </Col>
      <Col md={3} sm={6} xs={6} data-aos="zoom-in" data-aos-delay="200">
        <h3 className="impact-number"><CountUp end={45} duration={2.5} /></h3>
        <p className="impact-label">Workshops Conducted</p>
      </Col>
      <Col md={3} sm={6} xs={6} data-aos="zoom-in" data-aos-delay="300">
        <h3 className="impact-number"><CountUp end={20} duration={2} />+</h3>
        <p className="impact-label">Community Partners</p>
      </Col>
    </Row>
  </Container>
</section>


 <section className="py-5 testimonial-carousel-section mb-1">
          <div className="container  ">
            <Row className="align-items-end flex-column flex-md-row m-0">
              <Col xs={12} md={2} className="d-flex justify-content-center justify-content-md-start order-2 order-md-1 chocolates-col">
                <img
                  src={leftagrow}
                  alt="crop Left"
                  className="chocolate-image"
                  data-aos="zoom-in" data-aos-delay="200"
                />
              </Col>

              <Col xs={12} md={8} className="text-center order-1 order-md-2" data-aos="zoom-in" data-aos-delay="200">
                <h2 className="page-title text-center mb-4" data-aos="fade-up">
     Stories  <span style={{ color: '#078825' }}>That Inspire</span>
    </h2>
                <p className="text-muted mx-auto" style={{ maxWidth: 700 }}>
              Inspiring stories from those impacted by our organic farming and education efforts.
                </p>

              
                <Swiper
  modules={[Pagination, Autoplay]}
  spaceBetween={30}
  slidesPerView={1}
  pagination={{ clickable: true }}
  autoplay={{ delay: 3500 }}
  loop={true}
>
  {testimonials.map((item, idx) => (
    <SwiperSlide key={idx}>
      <div className="testimonial-slide  text-center  p-3 ">
        <div className="stars mb-2 ">
          {[...Array(5)].map((_, i) => (
            <FaStar key={i} />
          ))}
        </div>
        <p className="testimonial-quote">
          <span className="quote-mark">“</span>
          {item.text}
          <span className="quote-mark">”</span>
        </p>
        <p className="author-name">{item.role}</p>
      </div>
    </SwiperSlide>
  ))}
</Swiper>

              </Col>

              <Col xs={12} md={2} className="d-flex justify-content-center justify-content-md-end order-0 order-md-3 chocolates-col">
                <img
                  src={rightagrow}
                  alt="crop Right"
                  className="chocolateright-image"
                  data-aos="zoom-in" data-aos-delay="200"
                />
              </Col>
            </Row>
          </div>
        </section>


      </div>
    </>
  );
}
